import { isEqual } from '../utils/miscellaneous/objectHelpers';
import { useEffect } from 'react';

export const useSummaryItemDiffRegister = params => {
    const {
        diffs,
        summaryContext: {
            contexts
        },
        summaryItemId,
        values: {
            category,
            value,
            previousValue,
            textCode
        }
    } = params;

    useEffect(
        () => {
            if (diffs.status) {
                contexts.forEach(({ summaryId, updateRegistered }) => {
                    if(typeof updateRegistered === 'function' && summaryId) {
                        const diffItemToRegister = {
                            category,
                            value,
                            previousValue,
                            summaryItemId,
                            textCode
                        };

                        updateRegistered(
                            state => {
                                return state.find(v => isEqual(v, diffItemToRegister))
                                    ? state
                                    : [...state, diffItemToRegister];
                            }
                        );
                    }
                });
            }
        },
        [ ]
    );
};